const { RESOURCE_CONTAINER_SUBSCRIPTIONS } = require('./constants');

module.exports = `
  Resourcecontainers
  | where type == '${RESOURCE_CONTAINER_SUBSCRIPTIONS}'
  | project id, name, subscriptionId
  `;
